module.exports = __webpack_public_path__ + "static/media/attention.6754b412.svg";